import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import CompoenentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/purchase-requisition-components'
import { detailMode } from './constants'
import history from '../../history'

const RowRenderer = ({
  data, mode, onChangeHandler, initialData, mutationVariables, setMutationVariables,
}) => data.map(v => <CompoenentRenderer onChangeHandler={onChangeHandler} key={v.id} data={v} mode={mode} initialData={initialData} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} />)

const DetailModeHandler = (params, onChangeHandler, mutationVariables, setMutationVariables, initialData) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            type='flex'
            gutter={12}
            style={{ width: '100%' }}
          >
            <RowRenderer data={v} mode={mode} onChangeHandler={onChangeHandler} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} />
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/tire-patch')
      // mockup data
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
            style={{ width: '100%' }}
          >
            <RowRenderer data={v} mode={mode} initialData={initialData} onChangeHandler={onChangeHandler} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} />
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
